import _MpDecorator from "./MpDecorator.jsx"
import withInstall from "../../utils/withInstall"

export const MpDecorator = withInstall(_MpDecorator)
export default MpDecorator
